module.exports = __webpack_public_path__ + "static/img/qick_img01.58b4ea9c.png";